import React from 'react';
import './permissionDenied.scss';

import { useLogoutHook } from 'src/features/hooks';

export const PermissionDenied: React.FC = () => {
  const [handleLogout] = useLogoutHook();
  return (
    <>
      <div className="layout">
        <div className="title">
          <div className="bold">Maven </div>
          <div className="light">Driver Portal</div>
        </div>
        <div className="error">
          Unauthorized Access - You do not have sufficient permissions to view this page
        </div>
        <div className="logout">
          <button className="logout-btn" onClick={handleLogout}>
            Log out
          </button>
        </div>
      </div>
    </>
  );
};
